<template>
  <div
    id="app-rerouted"
    :class="shouldShowHeader ? 'pt-48 md-1:pt-80 [--nav-height:48px] md-1:[--nav-height:80px]' : '[--nav-height:0px]'"
  >
    <template v-if="shouldShowHeader">
      <SitterOnboardingNav v-if="onboardingLayout" />
      <GlobalNav v-else-if="isParent" />
      <SitterNav v-else-if="isSitter" />
      <PublicNav v-else />
    </template>
    <ContentfulBanner v-if="shouldShowBanner" :segment-event-name="'UpgradePricing_PostLogin_Banner'" />
    <div class="flex-1">
      <router-view />
    </div>
    <PoppinsCondensedFooter v-if="routerReady && shouldShowFooter" />
  </div>
</template>

<script>
import PoppinsCondensedFooter from '@/components/condensed_footer/PoppinsCondensedFooter.vue';
import ContentfulBanner from '@/components/contentful_banner/ContentfulBanner.vue';
import GlobalNav from '@/components/nav/GlobalNav.vue';
import PublicNav from '@/components/nav/PublicNav.vue';
import SitterNav from '@/components/nav/SitterNav.vue';
import SitterOnboardingNav from '@/components/navigation/SitterOnboardingNav.vue';
import { readMetaBoolean } from '@/lib/page';
import shouldShowContentfulBanner from '@/helpers/bannerDisplayLogic';

export default {
  name: 'App',
  components: {
    ContentfulBanner,
    GlobalNav,
    PoppinsCondensedFooter,
    PublicNav,
    SitterNav,
    SitterOnboardingNav,
  },
  data() {
    return {
      routerReady: false,
    };
  },
  computed: {
    isParent() {
      return this.account?.isParent() ?? false;
    },
    isSitter() {
      return this.account?.isSitter() ?? false;
    },
    shouldShowBanner() {
      return shouldShowContentfulBanner(this.account, this.$route.path);
    },
    shouldShowFooter() {
      return !this.$route.matched?.some((r) => r.meta?.shouldHideFooter);
    },
    nativeMobileApp() {
      return readMetaBoolean('native_mobile_app');
    },
    shouldShowHeader() {
      const hideFromMeta = this.$route.matched?.some((r) => r.meta?.hideMainHeader);
      return !hideFromMeta && !this.nativeMobileApp;
    },
    onboardingLayout() {
      return this.$route.matched?.some((r) => r.meta?.sitterOnboardingLayout);
    },
    account() {
      return this.$store.getters['account/getAccount'];
    },
  },
  async mounted() {
    // ensure account is loaded
    await this.ensureAccount();

    // Prevents footer from loading before content loads
    this.$router.onReady(() => {
      this.routerReady = true;
    });
  },
  methods: {
    async ensureAccount() {
      if (this.account) return;

      const shouldSkipAuth = this.$route.matched?.some((r) => r.meta?.skipAuth);
      if (shouldSkipAuth) return;

      try {
        await this.$store.dispatch('account/fetchAccountData');
      } catch (error) {
        console.error('Failed to fetch account data in App.vue:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
#app-rerouted {
  display: flex;
  flex-direction: column;
  min-height: calc(100dvh);
}
</style>
